import Select from "react-select";
import { compactSelectStyles } from "../../../utils/reactSelectControlStyles.js";
import styles from "../../../styles/Reports.module.css";
import ReportFilterSection from "./ReportFilterSection.jsx";
import ReportYearSelect from "./ReportYearSelect.jsx";

const YearBusinessEventPanel = ({
  t,
  reportI18nKeys,
  yearOptions,
  selectedYear,
  selectedReportOption,
  eventsOptions,
  selectedEvent,
  loadingEvents,
  businessEventSelectProps,
  handlers,
  eventClearable = false,
  eventDisabled,
}) => {
  const { onYearOptionChange, onSelectEvent } = handlers;

  return (
  <ReportFilterSection t={t} reportI18nKeys={reportI18nKeys}>
    <ReportYearSelect
      t={t}
      reportI18nKeys={reportI18nKeys}
      yearOptions={yearOptions}
      selectedYear={selectedYear}
      onYearOptionChange={onYearOptionChange}
      isDisabled={!selectedReportOption}
    />
    <div className={styles.filterItemContent}>
      <label className={styles.label}>{t(reportI18nKeys.EVENT)}</label>
      <Select
        options={eventsOptions}
        value={selectedEvent}
        onChange={onSelectEvent}
        isClearable={eventClearable}
        isDisabled={eventDisabled}
        isLoading={loadingEvents}
        placeholder={t(reportI18nKeys.EVENT_PLACEHOLDER)}
        styles={compactSelectStyles}
        {...businessEventSelectProps}
      />
    </div>
  </ReportFilterSection>
  );
};

export default YearBusinessEventPanel;
